module.exports = __webpack_public_path__ + "img/hello-tuts-player-avatar-mobile.9d52ddd1.png";